import Model from './model';
import User from './user';
import JSONReader from 'utils/reader';

export default class Song extends Model {
  static fields = [
    { name: 'id', default: 0 },
    { name: 'slug', default: '' },
    { name: 'title', default: '' },
    { name: 'album', default: {} },
    { name: 'author', mapping: (raw) => JSONReader({ model: User }, raw.author) },
    { name: 'duration', default: '00:00' },
    { name: 'favorites', default: 0 },
    { name: 'plays', default: 0 },
    { name: 'sound', default: '' },
    { name: 'tags', default: [] },
    { name: 'time', default: '' },
    'description',
    'lyric',
    'moods',
    'vocals',
    'instruments',
    'bpm'
  ];
}
